import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";

export default function Competitions() {
  const [competitions, setCompetitions] = useState([]);
  const [error, setError] = useState(false);

  useEffect(() => {
    fetch("/data/competitions.json")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch");
        return res.json();
      })
      .then((data) => {
        setCompetitions(data);
        setError(false);
      })
      .catch((err) => {
        console.error(err);
        setError(true);
      });
  }, []);

  return (
    <div className="relative pb-16 px-4">
      {/* Decorative background */}
      <div className="absolute inset-0 bg-gradient-to-r from-blue-50 via-white to-blue-50 -z-10" />

      <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12 relative z-10">
        🚀 Competitions
      </h2>

      {/* If error or no competitions */}
      {(error || competitions.length === 0) ? (
        <div className="text-center text-gray-500 mt-10 text-lg">
          ⚠️ No competitions right now. Please check back later.
        </div>
      ) : (
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3 mt-4">
          {competitions.map((comp, index) => (
            <motion.div
              key={comp.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.15, duration: 0.5 }}
              className="h-80"
            >
              <Link
                to={`/competitions/${comp.id}`}
                state={{ comp }}
                className="flex flex-col h-full w-full bg-white border rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition transform hover:-translate-y-1 cursor-pointer"
              >
                {/* Image */}
                <div className="relative h-48 w-full flex-shrink-0 z-0">
                  <img
                    src={comp.image}
                    alt={comp.title}
                    className="h-full w-full object-cover"
                    onError={(e) =>
                      (e.target.src = "/images/fallback.jpg") // Optional fallback image
                    }
                  />
                  {comp.awards && comp.awards.length > 0 && (
                    <div className="absolute top-3 right-3 bg-white text-gray-800 px-3 py-1 rounded-full text-sm font-semibold shadow-md z-10">
                      🏆 {comp.awards.length}
                    </div>
                  )}
                </div>

                {/* Text */}
                <div className="p-4 flex-1 flex flex-col justify-center items-center text-center z-10">
                  <h3 className="text-xl font-semibold text-gray-900 mb-1">
                    {comp.title}
                  </h3>
                  <p className="text-gray-500 text-sm">{comp.date}</p>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
}
